module.exports = __webpack_public_path__ + "static/media/error.49c29422.svg";